import * as React from 'react'
import { Box } from 'cs-kevlar-react'
import {
  makeStyles,
  createStyles,
  Theme,
} from 'cs-kevlar-react/lib/es/theming/theme'
import clsx from 'clsx'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    spacer: {
      flexGrow: 1,
      minHeight: 0,
    },
    centeredContainer: {
      margin: 'auto',
    },
  }),
)

type CenteredContainerProps = {
  children: any
  className?: string
  disableVerticalGutters?: boolean
  contentClassName?: string
}

export const CenteredContainer: React.FunctionComponent<CenteredContainerProps> = ({
  children,
  className,
  disableVerticalGutters,
  contentClassName,
}) => {
  const classes = useStyles({})

  return (
    <Box className={clsx(classes.root, className)}>
      {!disableVerticalGutters && <Box className={classes.spacer}></Box>}
      <Box className={clsx(classes.centeredContainer, contentClassName)}>
        {children}
      </Box>
      {!disableVerticalGutters && <Box className={classes.spacer}></Box>}
    </Box>
  )
}
